<div class="card rounded-top-left-0">
  <div class="card-header">
    <h1>Asociar Órdenes de Compra con Compras</h1>
  </div>

  <div class="card-body">
    <div class="mb-3 d-flex gap-3 align-items-end flex-wrap">
      <div class="text-muted">
        <i class="fa fa-circle-info"></i>
        Selecciona una orden (de cualquiera de las dos tablas) y marca las compras a asociar. Una compra solo puede estar asociada a una sola orden.
      </div>
    </div>

    <div class="row">
      <svg id="svg-container" #svgContainer></svg>

      <!-- ======== Columna Órdenes (2 tablas) ======== -->
      <div class="col-12 col-lg-6">
        <!-- NO asociadas -->
        <div class="mb-4">
          <h5 class="mb-2">Órdenes NO asociadas</h5>
          <div class="form-group">
            <label class="form-label">Buscar orden</label>
            <input type="text" [(ngModel)]="filterOrdersNot" (input)="debouncedFilterOrdersNot()"
                   class="form-control" placeholder="Número de orden / proveedor" />
          </div>

          <div class="table-responsive mt-3">
            <table class="table table-bordered" id="table-orders-not">
              <thead>
                <tr class="tr-middle">
                  <th></th>
                  <th>Número</th>
                  <th>Proveedor</th>
                  <th>Fecha</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let order of ordersNotAssociated"
                    [attr.data-id]="order.id"
                    (click)="selectOrder(order.id)"
                    [class.selected]="order.id === selectedOrderId">
                  <td>
                    <i [ngClass]="order.id === selectedOrderId ? 'fa-solid fa-circle' : 'fa-regular fa-circle'"></i>
                  </td>
                  <td class="relative">
                    {{ order.number }}

                    <span *ngIf="order.enteredIntoInventory" class="indicator"></span>
                  </td>
                  <td>{{ order.providerName }}</td>
                  <td>{{ order.date | date:'yyyy-MM-dd' }}</td>
                </tr>

                <tr *ngIf="ordersNotAssociated.length === 0">
                  <td colspan="5" class="text-muted">
                    <i class="fa fa-circle-info"></i> No se encontraron órdenes.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <app-simple-pagination
            id="orders-not-pag"
            [sizes]="[5,10,20]"
            (changed)="selectedOrderId = null; refreshOrdersNotPagination()"
            [elements]="paginationOrdersNot">
          </app-simple-pagination>
        </div>

        <!-- SÍ asociadas -->
        <div>
          <h5 class="mb-2">Órdenes asociadas</h5>
          <div class="form-group">
            <label class="form-label">Buscar orden</label>
            <input type="text" [(ngModel)]="filterOrdersYes" (input)="debouncedFilterOrdersYes()"
                   class="form-control" placeholder="Número de orden / proveedor" />
          </div>

          <div class="table-responsive mt-3">
            <table class="table table-bordered" id="table-orders-yes">
              <thead>
                <tr class="tr-middle">
                  <th></th>
                  <th>Número</th>
                  <th>Proveedor</th>
                  <th>Fecha</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let order of ordersAssociated"
                    [attr.data-id]="order.id"
                    (click)="selectOrder(order.id)"
                    [class.selected]="order.id === selectedOrderId">
                  <td>
                    <i [ngClass]="order.id === selectedOrderId ? 'fa-solid fa-circle' : 'fa-regular fa-circle'"></i>
                  </td>
                  <td class="relative">
                    {{ order.number }}

                    <span *ngIf="order.enteredIntoInventory" class="indicator"></span>
                  </td>
                  <td>{{ order.providerName }}</td>
                  <td>{{ order.date | date:'yyyy-MM-dd' }}</td>
                </tr>

                <tr *ngIf="ordersAssociated.length === 0">
                  <td colspan="5" class="text-muted">
                    <i class="fa fa-circle-info"></i> No se encontraron órdenes.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <app-simple-pagination
            id="orders-yes-pag"
            [sizes]="[5,10,20]"
            (changed)="selectedOrderId = null; refreshOrdersYesPagination()"
            [elements]="paginationOrdersYes">
          </app-simple-pagination>
        </div>
      </div>

      <!-- ======== Columna Compras ======== -->
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label class="form-label">Buscar compra</label>
          <input type="text" [(ngModel)]="filterPurchases" (input)="debouncedFilterPurchases()"
                 class="form-control" placeholder="Serie-Numero de compra / proveedor" />
          <div class="mb-3 row">
            <div class="col-md-6">
              <label class="form-label">Fecha inicio</label>
              <input type="date" class="form-control" [(ngModel)]="startDate" (change)="reloadPurchases()" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Fecha fin</label>
              <input type="date" class="form-control" [(ngModel)]="endDate" (change)="reloadPurchases()" />
            </div>
          </div>
        </div>

        <div class="table-responsive mt-3">
          <table class="table table-bordered" id="table-purchases">
            <thead>
              <tr class="tr-middle">
                <th></th>
                <th>Número</th>
                <th>Proveedor</th>
                <th>Fecha</th>
                <th>Total</th>
                <th class="text-center">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let p of purchases"
                  [attr.data-id]="p.id"
                  (click)="togglePurchase(p)"
                  [class.selected]="currentRelatedPurchaseIds.includes(p.id)"
                  [class.disabled]="isPurchaseLocked(p)">
                <td>
                  <i *ngIf="!isPurchaseLocked(p)"
                     [ngClass]="currentRelatedPurchaseIds.includes(p.id) ? 'fa-solid fa-circle' : 'fa-regular fa-circle'"></i>
                  <i *ngIf="isPurchaseLocked(p)" class="fa-solid fa-lock"></i>
                </td>
                <td>{{ p.number }}</td>
                <td>{{ p.providerName }}</td>
                <td>{{ p.date | date:'yyyy-MM-dd' }}</td>
                <td>{{ p.total | number:'1.2-2' }}</td>
                <td class="text-center">
                  <span *ngIf="!p.associatedOrderId" class="badge bg-secondary">Sin asociación</span>
                  <span *ngIf="p.associatedOrderId && p.associatedOrderId === selectedOrderId" class="badge bg-success">Asociada a esta orden</span>
                  <span *ngIf="p.associatedOrderId && p.associatedOrderId !== selectedOrderId" class="badge bg-warning text-dark">Asociada a otra orden</span>
                </td>
              </tr>

              <tr *ngIf="purchases.length === 0">
                <td colspan="6" class="text-muted">
                  <i class="fa fa-circle-info"></i> No se encontraron compras.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <app-simple-pagination
          id="purchases-pag"
          [sizes]="[5,10,20]"
          (changed)="refreshPurchasesPagination()"
          [elements]="paginationPurchases">
        </app-simple-pagination>
      </div>
    </div>

    <!-- Detalles -->
    <div class="row mt-4">
      <div class="col" *ngIf="currentOrderDetails">
        <h5>Detalles de la Orden:</h5>
        <table class="table table-bordered">
          <thead>
            <tr class="tr-middle">
              <th>Código</th>
              <th>Nombre</th>
              <th>Cantidad</th>
              <th>Costo</th>
              <th>Bodega</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let detail of currentOrderDetails">
              <td>{{ detail.productData.code }}</td>
              <td>{{ detail.productData.name }}</td>
              <td>{{ detail.quantity }}</td>
              <td>
                <div *ngIf="editingItem !== detail.id">
                  <span (click)="startEditing(detail.id)" class="profit-ammount">
                    {{ detail.cost }}
                    <i class="fa fa-edit span-hover"></i>
                  </span>
                </div>

                <div *ngIf="editingItem === detail.id" class="input-group input-group-sm">
                  <input type="number" [(ngModel)]="detail.cost" class="form-control" min="0" step="0.01" />
                  <button class="btn btn-success" [disabled]="loadingCost[detail.id]" (click)="updateCostOrderDetail(detail)">
                    <ng-container *ngIf="!loadingCost[detail.id]"><i class="fa fa-floppy-disk"></i></ng-container>
                    <ng-container *ngIf="loadingCost[detail.id]">
                      <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                      <span role="status"></span>
                    </ng-container>
                  </button>
                </div>
              </td>
              <td>
                {{ detail.warehouseData?.name || '—' }}
              </td>
            </tr>

            <tr *ngIf="currentOrderDetails.length === 0">
              <td colspan="4" class="text-muted">
                <i class="fa fa-circle-info"></i> No se encontraron detalles de la orden.
              </td>
            </tr>
          </tbody>
        </table>

        <div class="col-12 col-lg-6" *ngIf="selectedOrderId">
          <h5>Datos de Recepción</h5>

          <!-- Si no hay recibido -->
          <div *ngIf="!currentReceivedOrderDetails" class="text-muted">
            <i class="fa fa-circle-info"></i> Esta orden no tiene recepción registrada.
          </div>

          <!-- Si hay recibido -->
          <div *ngIf="currentReceivedOrderDetails" class="card">
            <div class="card-body">
              <div class="row g-2">
                <div class="col-6">
                  <small class="text-muted">Piloto</small>
                  <div>{{ currentReceivedOrderDetails.pilot || '—' }}</div>
                </div>

                <div class="col-6">
                  <small class="text-muted">Licencia</small>
                  <div>{{ currentReceivedOrderDetails.pilotLicense || '—' }}</div>
                </div>

                <div class="col-6">
                  <small class="text-muted">Placa carro</small>
                  <div>{{ currentReceivedOrderDetails.plateCar || '—' }}</div>
                </div>

                <div class="col-6">
                  <small class="text-muted">Placa plataforma</small>
                  <div>{{ currentReceivedOrderDetails.platePlatform || '—' }}</div>
                </div>

                <div class="col-6">
                  <small class="text-muted">Contenedor</small>
                  <div>{{ currentReceivedOrderDetails.container || '—' }}</div>
                </div>

                <div class="col-6">
                  <small class="text-muted">Fecha creación</small>
                  <div>{{ currentReceivedOrderDetails.creationDate | date:'yyyy-MM-dd HH:mm' }}</div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col" *ngIf="currentRelatedPurchaseIds && currentRelatedPurchaseIds.length > 0">
        <h5>Detalles de la(s) compra(s)</h5>
        <table class="table table-bordered">
          <thead>
            <tr class="tr-middle">
              <th>Código</th>
              <th>Nombre</th>
              <th>Cantidad</th>
              <th>Precio U</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let purchases of currentPurchases">
              <td>{{ purchases.productData.code }}</td>
              <td>{{ purchases.productData.name }}</td>
              <td>{{ purchases.quantity }}</td>
              <td>{{ purchases.price?.toFixed(2) }}</td>
            </tr>

            <tr *ngIf="currentPurchases.length === 0">
              <td colspan="4" class="text-muted">
                <i class="fa fa-circle-info"></i> No se encontraron detalles.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="currentRelatedPurchaseIds" class="d-flex flex-row justify-content-between">
        <button class="btn btn-success" [disabled]="getDisabledSave()" (click)="saveAssociation(false)">
          <i class="fa fa-floppy-disk" *ngIf="!loading"></i>
          <span *ngIf="loading" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
          GUARDAR CAMBIOS
        </button>

        <button class="btn btn-info" [disabled]="getDisabledSave()" (click)="saveAssociation(true)">
          <i class="fa fa-floppy-disk" *ngIf="!loading"></i>
          <span *ngIf="loading" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
          FINALIZAR Y GUARDAR
        </button>
      </div>
    </div>
  </div>
</div>
